import React, { useState, useEffect } from 'react'
import styles from './modal.module.css'
import { Button, IconButton, Box } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import * as api from '../../pages/services/api'
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';

export default function ModalDeleteUser({ onClose, uid, fname, lname }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const save = async () => {
        setLoading(true);
        let res = await api.deleteUser(uid);
        setLoading(false);
        if (res) {
          if (res['data']['code'] === 200) {
              alert('ลบสำเร็จ');
              onClose();
            //   navigate('/manageUsers');
            window.location.reload();
          } else {
            console.log(res)
              //alert(res['data']['message']);
          }
        } else {
          alert('ไม่ตอบสนอง');
        }
    };

    

    useEffect(() => {
        console.log(uid)
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>แจ้งเตือน</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={onClose}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', textAlign: 'center', gridGap: '20px' }}>
                        <Box sx={{
                            fontSize: '16px',
                            "@media (max-width: 800px)": {
                                fontSize: '14px'
                            }
                        }}>
                            ยืนยันการลบข้อมูลของ '{fname} {lname}' หรือไม่ ?
                        </Box>
                        <Box>
                            <Button
                                variant='contained'
                                onClick={save}
                            >
                                ยืนยัน
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
}